import {httpsCallable} from "firebase/functions";
// @ts-ignore -- "FirebaseUtils" is resolved by the web bundler, not by tsc
import {functions} from "FirebaseUtils";
import LogService from "services/LogService.js";

/**
 * Profile updates go through the shared `updateUserProfile` callable (owned by
 * WSDB, same Firebase project) rather than writing to the RTDB user record
 * directly, so web and native stay consistent. The callable identifies the
 * user from the auth token — never pass a uid. Field names match the callable
 * contract (see WSDB routes/user.ts and android ProfileFunctions.kt).
 */
export interface ProfileUpdate {
  name?: string;
  email?: string;
  marketing?: boolean;
  country?: string;
  weight_kg?: number | null;
  height_cm?: number | null;
  date_of_birth?: string | null;
  gender?: string;
  raw_sports?: number[];
  fcm_token?: string;
  bio?: string;
  favorite_spot?: string;
}

export const updateUserProfile = async (params: ProfileUpdate): Promise<boolean> => {
  try {
    const callable = httpsCallable<ProfileUpdate, {success: boolean; error?: string}>(functions, "updateUserProfile");
    const result = await callable(params);
    if (!result.data?.success) {
      LogService.addErrorLogAsync("", "updateUserProfile failed: " + (result.data?.error || "unknown"), false, true);
      return false;
    }
    return true;
  } catch (error: any) {
    LogService.addErrorLogAsync("", "updateUserProfile error: " + error.message, false, true);
    return false;
  }
};
